module.exports = __webpack_public_path__ + "img/systalk-logo.44931687.png";